import { gql } from '@apollo/client';

const CHECK_EXPIRED_TOKEN_QUERY = gql`
  query checkExpiredToken {
    checkExpiredToken
  }
`;

export default CHECK_EXPIRED_TOKEN_QUERY;
